import { gql } from '@apollo/client';

export default gql`
  fragment LimitSetDetails on LimitSet {
    projectMaxCount
    userMaxCount
    videoMaxBytes
    videoMaxSeconds
  }
`;
